var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"responsive",rawName:"v-responsive",value:({
  'media-992': function (el) { return el.width < 992; },
  'media-576': function (el) { return el.width < 576; },
  'media-480': function (el) { return el.width < 480; }
}),expression:"{\n  'media-992': el => el.width < 992,\n  'media-576': el => el.width < 576,\n  'media-480': el => el.width < 480\n}"}]},[_c('PageContainer',{attrs:{"loaded":false}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }